export default class scrollToBlock {
    constructor() {
        this.linkToScroll = 'a[href^="#"]';

        $(document).on('click', this.linkToScroll, this.linkToScrollClickHandler.bind(this));
    }

    linkToScrollClickHandler(e) {
        const href = $(e.currentTarget).attr('href');

        $('html, body').animate({
            scrollTop: $(href).offset().top,
        });

        return false;
    }
};
